export default defineNuxtPlugin((nuxtApp) => {
  const { currentLocation } = useLocationStore()
  const { currentUser } = useAuthStore()

  nuxtApp.hook('app:mounted', () => {
    window.Config = {
      city: currentLocation?.name || '',
      user: undefined,
    }

    if (currentUser) {
      window.Config.user = {
        user: currentUser.email,
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
      }
    }
  })
})
